function initCaseSwitcher(section) {

  const buttons = section.querySelectorAll(".case-btn")
  const panels = section.querySelectorAll(".case-panel")

  buttons.forEach(button => {

    button.addEventListener("click", () => {

      const caseId = button.dataset.case

      panels.forEach(panel => {
        panel.classList.toggle(
          "active",
          panel.dataset.case === caseId
        )
      })

      buttons.forEach(btn => btn.removeAttribute("data-active"))
      button.setAttribute("data-active", "true")

    })

  })

}

document.querySelectorAll(".case-switcher").forEach(section => {
  initCaseSwitcher(section)
})
